import { useNavigator } from '@repo/toolkit/use-navigator'
import { SheetOutlineIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createYouthAndSportNumber } from '../../api/youth-and-sport-numbers/create-youth-and-sport-number'
import UserNavBar from '../../components/elements/nav-bar'
import YouthAndSportNumberForm from '../../components/pages/youth-and-sport-number/youth-and-sport-number-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const YouthAndSportNumberCreatePage = () => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createYouthAndSportNumber,
    onError: showAxiosError,
    onSuccess: () => toast.success("N° d'enregistrements créé avec succès")
  })

  return (
    <div>
      <UserNavBar title="Créer le N° d'enregistrement Jeunesse et Sport" icon={SheetOutlineIcon} />
      <div className="h-4" />
      <YouthAndSportNumberForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            await mutateAsync(values)
            back(Paths.YOUTH_AND_SPORT_NUMBER_LIST_PAGE)
          },
          onCancel: () => back(Paths.YOUTH_AND_SPORT_NUMBER_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default YouthAndSportNumberCreatePage
